<template>
    <div class="row default mb-4">
        <div class="col-lg-12">
            <div class="np-header1 np-pb-3">{{ $t("UI.dashboard.welcome") }},  {{ userStore.userShortName }}</div>
            <HomeNavigation activeTab="summary" @callSwitchScreen="callSwitchScreen"/>            
        </div>
    </div>
    <div class="row flex-grow-1">
        <div class="col-lg-5 d-flex flex-column h-100">           

            <div class="np-widgets-panel pb-4">
                <div class="np-widget">
                    <div class="np-widget-top">
                        <p class="np-font-l np-f-medium np-lh-l">{{ tasksObject.today }}</p>
                        <svg><use href="@/assets/images/icons/calendar-empty.svg#icon"></use></svg>
                    </div>                        
                    <div class="np-widget-bottom">
                        <span class="np-lh-m">{{ $t("UI.dashboard.toToday") }}</span>
                        <svg style="width: 20px; height: 20px;"><use href="@/assets/images/icons/eye20.svg#icon"></use></svg>
                    </div>
                </div>

                <div class="np-widget">
                    <div class="np-widget-top">
                        <p class="np-font-l np-f-medium np-lh-l">{{ tasksObject.completed }}</p>
                        <svg class="np-color-success"><use href="@/assets/images/icons/calendar-complete.svg#icon"></use></svg>
                    </div>
                    <div class="np-widget-bottom">
                        <span class="np-lh-m">{{ $t("UI.dashboard.toCompleted") }}</span>
                        <svg style="width: 20px; height: 20px;"><use href="@/assets/images/icons/eye20.svg#icon"></use></svg>
                    </div>
                </div>
                
                <div class="np-widget">
                    <div class="np-widget-top">
                        <p class="np-font-l np-f-medium np-lh-l">{{ tasksObject.failed }}</p>
                        <svg class="np-color-danger"><use href="@/assets/images/icons/calendar-fail.svg#icon"></use></svg>
                    </div>                        
                    <div class="np-widget-bottom">
                        <span class="np-lh-m">{{ $t("UI.dashboard.toFailed") }}</span>
                        <svg style="width: 20px; height: 20px;"><use href="@/assets/images/icons/eye20.svg#icon"></use></svg>
                    </div>
                </div>
            </div>    

            <div class="np-header3 vertical-align-center mb-2">
                <svg class="np-mr-2"><use href="@/assets/images/icons/folder.svg#icon"></use></svg> {{ $t("UI.projects") }}
            </div>
            <div class="np-panel flex-grow-1">
                <div class="np-panel-header justify-content-between np-p-2">
                    <select class="np-select" v-model="projectSorting" @change="handleProjectSortingChange">
                        <option value="" disabled selected>{{ $t("sort.placeholder") }}</option>
                        <option value="name" data-direction="asc">{{ $t("sort.byNameAsc") }}</option>
                        <option value="name" data-direction="desc">{{ $t("sort.byNameDesc") }}</option>
                        <option value="completion_percent" data-direction="desc">{{ $t("sort.byPercentAsc") }}</option>
                        <option value="completion_percent" data-direction="asc">{{ $t("sort.byPercentDesc") }}</option>
                    </select>
                    <button class="np-btn np-btn-primary np-p-custom-0">
                        <svg><use href="@/assets/images/icons/filter.svg#icon"></use></svg>
                    </button>
                </div>
                <div class="np-panel-body np-overflow-hidden np-p-0">
                    <div class="np-group np-group-column">
                        <PerfectScrollbar>
                            <ul class="np-list">
                                <li class="no-wrap" role="button" v-for="project in sortedProjects" :key="project.id">
                                    <a class="np-color-primary" :href="'/project/' + project?.id">
                                        <div class="np-group px-3 py-2 align-items-center">
                                            <div class="np-badge-s np-gray me-2">
                                                <svg class="icon"><use href="@/assets/images/icons/comment.svg#icon"></use></svg>
                                                14
                                            </div>
                                            <div class="np-badge-s np-gray me-2">
                                                <svg class="icon"><use href="@/assets/images/icons/notification.svg#icon"></use></svg>
                                                2
                                            </div>                                                                                        
                                            <div class="no-wrap np-ellipsis flex-grow-1">{{ project.name }}</div>
                                            <div class="np-badge me-2" :class="getProgressColor(project.completion_percent)">{{ project.completion_percent }}%</div>
                                            <div class="np-badge-s np-danger">
                                                <svg class="icon20"><use href="@/assets/images/icons/bellx20.svg#icon"></use></svg>
                                            </div>
                                            <div class="np-badge-s np-color-primary-400 py-0 pe-0">
                                                <svg><use href="@/assets/images/icons/arrow-right.svg#icon"></use></svg>
                                            </div>
                                        </div>
                                    </a>
                                </li>                
                            </ul>
                        </PerfectScrollbar>
                    </div>
                </div>
            </div>                   

            <!--
            <div class="row">
                <div class="col-lg-12">
                    <div class="np-group np-group-row pt-3">
                        <div class="np-field-group np-with-icon-right w-100">
                            <input type="text" class="np-text-input np-outline" :placeholder="$t('search.search')" v-model="filters.name"/>
                            <svg class="field-icon at-left"><use href="@/assets/images/icons/search.svg#icon"></use></svg>
                        </div>                                                                      
                    </div>                  
                </div>
            </div>
            -->          
        </div>
        <div class="col-lg-7 d-flex flex-column h-100">
            <div class="row flex-grow-1">
                <div class="col-lg-5 d-flex flex-column h-100">
                    <div class="row">
                        <div class="col">
                            <div class="np-header3 vertical-align-center mb-2">
                                <svg class="np-mr-2"><use href="@/assets/images/icons/folder.svg#icon"></use></svg> {{ $t("UI.summary.projectsStatistics") }}
                            </div>
                            <div class="np-panel flex-grow-1">
                                <div class="np-panel-body np-overflow-hidden p-4">
                                    <div class="np-group np-group-column">
                                        <div class="np-group">
                                            <div class="pb-2 me-2">{{ $t("UI.summary.complete") }} <span class="np-font-s"><span class="np-color-success">15</span> / 99</span></div>
                                            <svg style="width: 20px; height: 20px;"><use href="@/assets/images/icons/eye20.svg#icon"></use></svg>
                                        </div>
                                        <div class="np-progressbar np-progressbar-m">
                                            <div class="np-progressbar-track np-progressbar-success" :style="{'width': 65 +'%', 'max-width': '100%'}"></div>
                                        </div> 
                                    </div>
                                    <div class="np-group np-group-column pt-4">
                                        <div class="np-group">
                                            <div class="pb-2 me-2">{{ $t("UI.summary.onTime") }} <span class="np-font-s"><span class="np-color-danger">15</span> / 99</span></div>
                                            <svg style="width: 20px; height: 20px;"><use href="@/assets/images/icons/eye20.svg#icon"></use></svg>
                                        </div>
                                        <div class="np-progressbar np-progressbar-m">
                                            <div class="np-progressbar-track np-progressbar-danger" :style="{'width': 45 +'%', 'max-width': '100%'}"></div>
                                        </div> 
                                    </div>
                                    <div class="np-group np-group-column pt-4">
                                        <div class="np-group">
                                            <div class="pb-2 me-2">{{ $t("UI.summary.atRisk") }} <span class="np-font-s"><span class="np-color-pink-400">15</span> / 99</span></div>
                                            <svg style="width: 20px; height: 20px;"><use href="@/assets/images/icons/eye20.svg#icon"></use></svg>
                                        </div>
                                        <div class="np-progressbar np-progressbar-m">
                                            <div class="np-progressbar-track np-progressbar-pink" :style="{'width': 35 +'%', 'max-width': '100%'}"></div>
                                        </div> 
                                    </div>
                                    <div class="np-group np-group-column pt-4 pb-4">
                                        <div class="np-group">
                                            <div class="pb-2 me-2">{{ $t("UI.summary.delays") }} <span class="np-font-s"><span class="np-color-primary-400">15</span> / 99</span></div>
                                            <svg style="width: 20px; height: 20px;"><use href="@/assets/images/icons/eye20.svg#icon"></use></svg>
                                        </div>
                                        <div class="np-progressbar np-progressbar-m">
                                            <div class="np-progressbar-track" :style="{'width': 15 +'%', 'max-width': '100%'}"></div>
                                        </div> 
                                    </div>  
                                    <div class="np-group np-group-column pt-2 pb-2">
                                        <div class="np-group">
                                            <div class="pb-2 me-2">{{ $t("UI.summary.projectsPending") }}</div>
                                            <svg style="width: 20px; height: 20px;"><use href="@/assets/images/icons/eye20.svg#icon"></use></svg>
                                        </div>
                                        <div class="np-f-bold">
                                            6
                                        </div> 
                                    </div>                                                                                                               
                                </div>
                            </div>  
                        </div>
                    </div>
                    <div class="np-header3 vertical-align-center mt-3 mb-2">
                        <svg class="np-mr-2"><use href="@/assets/images/icons/teams.svg#icon"></use></svg> {{ $t("UI.summary.teams") }}
                    </div>
                    <div class="np-panel flex-grow-1">
                        <div class="np-panel-body np-overflow-hidden p-4">
                            <div class="np-group np-group-column pb-4">
                                <div class="np-group">
                                    <div class="pb-2 me-2">{{ $t("UI.summary.employeesWithOverdueTasks") }} <span class="np-color-success">15%</span></div>
                                </div>
                            </div>                            
                            <div class="np-group np-group-column">
                                <div class="np-group">
                                    <div class="pb-2 me-2">{{ $t("UI.summary.averageWorkload") }}</div>
                                </div>                                
                                <ProgressBar 
                                    min="0" 
                                    max="100" 
                                    current="15" 
                                    classes="np-progressbar-m"
                                    color="np-color-default"
                                    :scalesVisible="{
                                        min: true,
                                        max: true,
                                        middle: true
                                    }"
                                    :labelsVisible="{
                                        min: true,
                                        max: true                                                    
                                    }"
                                />
                            </div>
                            <div class="np-group np-group-column pt-4 pb-4">
                                <div class="np-group">
                                    <div class="pb-2 me-2">{{ $t("UI.summary.involvement") }} <span class="np-font-s"><span class="np-color-primary-400">15</span> / 99</span></div>
                                </div>
                                <div class="np-progressbar np-progressbar-m">
                                    <div class="np-progressbar-track np-progressbar-info" :style="{'width': 15 +'%', 'max-width': '100%'}"></div>
                                </div> 
                            </div>                              
                        </div>
                    </div>                                        
                </div>            
                <div class="col-lg-7 d-flex flex-column h-100">
                    <div class="row">
                        <div class="col">
                            <div class="np-header3 vertical-align-center mb-2">
                                <svg class="np-mr-2"><use href="@/assets/images/icons/calendar-empty.svg#icon"></use></svg> {{ $t("UI.summary.tasksStatistics") }}
                            </div>
                            <div class="np-panel flex-grow-1">
                                <div class="np-panel-body np-overflow-hidden p-4">
                                    <div class="np-group np-group-column">
                                        <div class="row">
                                            <div class="col-6">
                                                <div class="np-group np-group-column">
                                                    <div class="np-group">
                                                        <div class="pb-2 me-2">{{ $t("UI.summary.complete") }} <span class="np-font-s"><span class="np-color-success">15</span> / 99</span></div>
                                                        <svg style="width: 20px; height: 20px;"><use href="@/assets/images/icons/eye20.svg#icon"></use></svg>
                                                    </div>
                                                    <div class="np-progressbar np-progressbar-m">
                                                        <div class="np-progressbar-track np-progressbar-success" :style="{'width': 65 +'%', 'max-width': '100%'}"></div>
                                                    </div> 
                                                </div> 
                                                <div class="np-group np-group-column pt-4">
                                                    <div class="np-group">
                                                        <div class="pb-2 me-2">{{ $t("UI.summary.onTime") }} <span class="np-font-s"><span class="np-color-danger">15</span> / 99</span></div>
                                                        <svg style="width: 20px; height: 20px;"><use href="@/assets/images/icons/eye20.svg#icon"></use></svg>
                                                    </div>
                                                    <div class="np-progressbar np-progressbar-m">
                                                        <div class="np-progressbar-track np-progressbar-danger" :style="{'width': 45 +'%', 'max-width': '100%'}"></div>
                                                    </div> 
                                                </div>                                                                               
                                            </div>
                                            <div class="col-6">
                                                <div class="np-group np-group-column">
                                                    <div class="np-group">
                                                        <div class="pb-2 me-2">{{ $t("UI.summary.overdue") }} <span class="np-font-s"><span class="np-color-warning">15</span> / 99</span></div>
                                                        <svg style="width: 20px; height: 20px;"><use href="@/assets/images/icons/eye20.svg#icon"></use></svg>
                                                    </div>
                                                    <div class="np-progressbar np-progressbar-m">
                                                        <div class="np-progressbar-track np-progressbar-warning" :style="{'width': 35 +'%', 'max-width': '100%'}"></div>
                                                    </div> 
                                                </div>
                                                <div class="np-group np-group-column pt-4 pb-4">
                                                    <div class="np-group">
                                                        <div class="pb-2 me-2">{{ $t("UI.summary.atRisk") }} <span class="np-font-s"><span class="np-color-pink-400">15</span> / 99</span></div>
                                                        <svg style="width: 20px; height: 20px;"><use href="@/assets/images/icons/eye20.svg#icon"></use></svg>
                                                    </div>
                                                    <div class="np-progressbar np-progressbar-m">
                                                        <div class="np-progressbar-track np-progressbar-pink" :style="{'width': 15 +'%', 'max-width': '100%'}"></div>
                                                    </div> 
                                                </div>                                         
                                            </div>
                                            <div class="col-12">
                                                <div class="np-group np-group-column pt-2 pb-4">
                                                    <div class="np-group">
                                                        <div class="pb-2 me-2">{{ $t("UI.summary.delays") }} <span class="np-font-s"><span class="np-color-primary-400">15</span> / 99</span></div>
                                                        <svg style="width: 20px; height: 20px;"><use href="@/assets/images/icons/eye20.svg#icon"></use></svg>
                                                    </div>

                                                    <div class="np-progressbar np-progressbar-m" style="max-width: unset;">
                                                        <div class="np-progressbar-track" :style="{'width': 15 +'%', 'max-width': '100%'}"></div>
                                                    </div> 
                                                </div>                                                                              
                                            </div>
                                            <div class="col-6">
                                                <div class="np-group np-group-column pt-2 pb-2">
                                                    <div class="np-group">
                                                        <div class="pb-2">{{ $t("UI.summary.averageTaskTime") }}</div>
                                                    </div>
                                                    <div class="np-f-bold">
                                                        6
                                                    </div> 
                                                </div>                                           
                                            </div>
                                            <div class="col-6">
                                                <div class="np-group np-group-column pt-2 pb-2">
                                                    <div class="np-group">
                                                        <div class="pb-2">{{ $t("UI.summary.averageDeviation") }}</div>
                                                    </div>
                                                    <div class="np-f-bold">
                                                        6
                                                    </div> 
                                                </div>                                           
                                            </div>                                    
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>  
                    <div class="row np-flex-1">
                        <div class="col d-flex flex-column h-100">
                            <div class="np-header3 vertical-align-center mt-3 mb-2">
                                <svg class="np-mr-2"><use href="@/assets/images/icons/teams.svg#icon"></use></svg> {{ $t("UI.summary.teamsRating") }}
                            </div>
                            <div class="np-panel np-flex-1">
                                <div class="np-panel-body np-overflow-hidden np-p-0">
                                    <div class="np-group np-group-column">
                                        <PerfectScrollbar>
                                            <ul class="np-list">
                                                <li class="no-wrap" role="button">
                                                    <a class="np-color-primary" href="#">
                                                        <div class="np-group px-3 py-2 align-items-center">                                                                         
                                                            <div class="no-wrap np-ellipsis flex-grow-1">Команда разработки</div>
                                                            <div class="np-color-success">55%</div>
                                                            <div class="np-badge-s np-color-primary-400 py-0 pe-0">
                                                                <svg><use href="@/assets/images/icons/arrow-right.svg#icon"></use></svg>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </li>   
                                                <li class="no-wrap" role="button">
                                                    <a class="np-color-primary" href="#">
                                                        <div class="np-group px-3 py-2 align-items-center">                                                                         
                                                            <div class="no-wrap np-ellipsis flex-grow-1">Команда UX</div>
                                                            <div class="np-color-danger">15%</div>
                                                            <div class="np-badge-s np-color-primary-400 py-0 pe-0">
                                                                <svg><use href="@/assets/images/icons/arrow-right.svg#icon"></use></svg>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </li>
                                                <li class="no-wrap" role="button">
                                                    <a class="np-color-primary" href="#">
                                                        <div class="np-group px-3 py-2 align-items-center">                                                                         
                                                            <div class="no-wrap np-ellipsis flex-grow-1">Команда маркетинга</div>
                                                            <div class="np-color-warning">25%</div>
                                                            <div class="np-badge-s np-color-primary-400 py-0 pe-0">
                                                                <svg><use href="@/assets/images/icons/arrow-right.svg#icon"></use></svg>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </li>
                                                <li class="no-wrap" role="button">
                                                    <a class="np-color-primary" href="#">
                                                        <div class="np-group px-3 py-2 align-items-center">                                                                         
                                                            <div class="no-wrap np-ellipsis flex-grow-1">Команда фронтенда</div>
                                                            <div class="np-color-success">55%</div>
                                                            <div class="np-badge-s np-color-primary-400 py-0 pe-0">
                                                                <svg><use href="@/assets/images/icons/arrow-right.svg#icon"></use></svg>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </li>     
                                                <li class="no-wrap" role="button">
                                                    <a class="np-color-primary" href="#">
                                                        <div class="np-group px-3 py-2 align-items-center">                                                                         
                                                            <div class="no-wrap np-ellipsis flex-grow-1">Команда разработки</div>
                                                            <div class="np-color-success">55%</div>
                                                            <div class="np-badge-s np-color-primary-400 py-0 pe-0">
                                                                <svg><use href="@/assets/images/icons/arrow-right.svg#icon"></use></svg>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </li>   
                                                <li class="no-wrap" role="button">
                                                    <a class="np-color-primary" href="#">
                                                        <div class="np-group px-3 py-2 align-items-center">                                                                         
                                                            <div class="no-wrap np-ellipsis flex-grow-1">Команда UX</div>
                                                            <div class="np-color-danger">15%</div>
                                                            <div class="np-badge-s np-color-primary-400 py-0 pe-0">
                                                                <svg><use href="@/assets/images/icons/arrow-right.svg#icon"></use></svg>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </li>
                                                <li class="no-wrap" role="button">
                                                    <a class="np-color-primary" href="#">
                                                        <div class="np-group px-3 py-2 align-items-center">                                                                         
                                                            <div class="no-wrap np-ellipsis flex-grow-1">Команда маркетинга</div>
                                                            <div class="np-color-warning">25%</div>
                                                            <div class="np-badge-s np-color-primary-400 py-0 pe-0">
                                                                <svg><use href="@/assets/images/icons/arrow-right.svg#icon"></use></svg>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </li>
                                                <li class="no-wrap" role="button">
                                                    <a class="np-color-primary" href="#">
                                                        <div class="np-group px-3 py-2 align-items-center">                                                                         
                                                            <div class="no-wrap np-ellipsis flex-grow-1">Команда фронтенда</div>
                                                            <div class="np-color-success">55%</div>
                                                            <div class="np-badge-s np-color-primary-400 py-0 pe-0">
                                                                <svg><use href="@/assets/images/icons/arrow-right.svg#icon"></use></svg>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </li>                                                                                                                                                                                                          
                                            </ul>
                                        </PerfectScrollbar>
                                    </div>
                                </div>
                            </div>                     
                        </div>
                    </div>
                </div> 
            </div>
        </div>        
    </div>
    <!--
    <div class="row flex-grow-1">
        <div class="col-lg-12 h-100">
            <div class="np-panel h-100 np-overflow-hidden">
                <PerfectScrollbar>
                        <table class="np-table h-100">
                            <thead class="np-table-header">
                                <tr class="np-table-row">
                                    <th class="np-table-header-cell" style="width: 25%;">
                                        <div class="np-group">
                                            <div class="flex-grow-1">{{ $t("sort.task") }}</div>
                                            <button class="np-btn-link" @click="attachSorting('title')">
                                                <img class="np-ml-1 np-mr-1" :src="sortIcon('title')" /> 
                                            </button>
                                        </div>
                                    </th>
                                    <th class="np-table-header-cell">
                                        <div class="np-group">
                                            <div class="flex-grow-1">{{ $t("sort.project") }}</div>
                                            <button class="np-btn-link" @click="attachSorting('status')">
                                                <img class="np-ml-1 np-mr-1" :src="sortIcon('status')" /> 
                                            </button>
                                        </div>
                                    </th>                                     
                                    <th class="np-table-header-cell" style="width: 120px;">
                                        <div class="np-group">
                                            <div class="flex-grow-1">{{ $t("sort.expired") }}</div>
                                            <button class="np-btn-link" @click="attachSorting('deadline')">
                                                <img class="np-ml-1 np-mr-1" :src="sortIcon('deadline')" /> 
                                            </button>
                                        </div>
                                    </th>                                                          

                                    <th class="np-table-header-cell" style="width: 80px;">
                                        <div class="np-group">
                                            <div class="flex-grow-1">%</div>
                                            <button class="np-btn-link">
                                                <svg class="np-ml-1 np-mr-1"><use href="@/assets/images/icons/list2.svg#icon"></use></svg> 
                                            </button>
                                        </div>
                                    </th>                                                          
                                    <th class="np-table-header-cell">
                                        <div class="np-group">
                                            <div class="flex-grow-1">{{ $t("sort.priority") }}</div>
                                            <button class="np-btn-link" @click="attachSorting('priority')">
                                                <img class="np-ml-1 np-mr-1" :src="sortIcon('priority')" /> 
                                            </button>
                                        </div>
                                    </th>   
                                    <th class="np-table-header-cell">
                                        <div class="np-group">
                                            <div class="flex-grow-1">{{ $t("sort.begin") }}</div>
                                            <button class="np-btn-link" @click="attachSorting('date_planned_start')">
                                                <img class="np-ml-1 np-mr-1" :src="sortIcon('date_planned_start')" />  
                                            </button>
                                        </div>
                                    </th>                                             
                                    <th class="np-table-header-cell">
                                        <div class="np-group">
                                            <div class="flex-grow-1">{{ $t("sort.end") }}</div>
                                            <button class="np-btn-link" @click="attachSorting('date_planned_end')">
                                                <img class="np-ml-1 np-mr-1" :src="sortIcon('date_planned_end')" /> 
                                            </button>
                                        </div>
                                    </th>                                                                                                                   
                                </tr>
                            </thead>
                            <tbody class="np-table-body">
                                <template v-for="eTask in this.sortedTaskList">
                                    <tr class="np-table-row" @dblclick="showModTask(eTask.id, eTask.status.id)">
                                        <td class="np-table-cell">
                                            <div class="np-group justify-content-between align-items-center">
                                                <button class="np-btn-sm np-toggler me-2" 
                                                        v-if="eTask.subtask.length > 0" 
                                                        @click.stop="this.expandRow($event, 'pTask_' + eTask.id)">
                                                </button>                                                
                                                <div class="flex-grow-1 np-ellipsis" :class="{ 'completed' : eTask.date_actual_end }">
                                                    {{ eTask.title }}
                                                </div>
                                                <div class="np-table-badge ms-1" v-if="eTask.subtask.length > 0">
                                                    <svg class="np-mr-1"><use href="@/assets/images/icons/folder-tree.svg#icon"></use></svg>
                                                    <span class="np-font-s np-lh-s">{{ eTask.subtask.length }}</span> 
                                                </div>
                                            </div>
                                        </td>
                                        <td class="np-table-cell">{{ eTask.title }}</td>
                                        <td class="np-table-cell">
                                            <IndicatorDaysTo 
                                                :dateStart="eTask.date_planned_start"
                                                :dateEnd="eTask.date_planned_end" 
                                                v-if="!eTask.date_actual_end"
                                            />                                         
                                        </td>                                        
                                        <td class="np-table-cell"><span class="np-badge np-warning">33%</span></td>
                                        <td class="np-table-cell">
                                            <div class="np-badge text-center" :class="getPriorityObject(eTask.priority).class">
                                                {{ $t(getPriorityObject(eTask.priority).label) }}
                                            </div>                                                                
                                        </td>
                                        <td class="np-table-cell">{{ localeDateTime(eTask.date_planned_start) }}</td>
                                        <td class="np-table-cell">{{ localeDateTime(eTask.date_planned_end) }}</td>
                                    </tr>
                                    <template v-for="eSubTask in eTask.subtask">
                                        <div class="np-table-row hidden" :class="'pTask_' + eTask.id" @dblclick="showModTask(eTask.id, eTask.status.id, 'params', eSubTask.id)">
                                            <div class="np-table-cell ps-4">
                                                <div class="np-group justify-content-between align-items-center ps-3">
                                                    <svg class="np-mr-1"><use href="@/assets/images/icons/folder-tree.svg#icon"></use></svg>
                                                    <div class="flex-grow-1 np-ellipsis">{{ eSubTask.title }}</div>
                                                </div>
                                            </div>
                                            <div class="np-table-cell">
                                                <IndicatorDaysTo :dateStart="eSubTask.date_planned_start" :dateEnd="eSubTask.date_planned_end" v-if="!eSubTask.date_actual_end"/>                       
                                            </div>
                                            <div class="np-table-cell">{{ eSubTask.title }}</div>
                                            <div class="np-table-cell"><span class="np-badge np-warning">33%</span></div>
                                            <div class="np-table-cell">
                                                <div class="np-profile-list mt-2">
                                                    <div class="np-profile-list__item" v-for="item_s in eSubTask.performer">
                                                        <CobaltProfile 
                                                            :firstName="item_s.first_name" 
                                                            :lastName="item_s.last_name" 
                                                            :avatar="item_s.imageFile"
                                                            :short="eSubTask.performer.length > 1 ? true : false"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="np-table-cell">
                                            
                                            </div>
                                            <div class="np-table-cell">{{ localeDateTime(eSubTask.date_planned_start) }}</div>
                                            <div class="np-table-cell">{{ localeDateTime(eSubTask.date_planned_end) }}</div>
                                        </div>
                                    </template>                                    
                                </template>
                            </tbody>                                                                                         
                        </table>
                </PerfectScrollbar>
            </div>
        </div>
    </div>    
    -->
</template>

<script>

import { useSettingsStore } from "@/stores/settingsStore"
import { useUserStore } from '@/stores/userStore'

import HomeNavigation from "@/components/dashboard/home/Navigation.vue"
import IndicatorDaysTo  from "@/components/elements/IndicatorDaysTo.vue" 
import { localeDateTime, eventDate, nameColor, priorityValues } from '@/utils/format'
import { mapGetters, mapActions } from 'vuex'
import Config from '../../../config'
import ProgressBar from "@/components/elements/ProgressBar.vue"

function compareValues(a, b) {
  if (typeof a === 'string' && typeof b === 'string') {
    return a.localeCompare(b, undefined, { numeric: true }); // Сравнение строк с учетом чисел
  }
  if (a < b) return -1;
  if (a > b) return 1;
  return 0;
}

function daysTo(date, dateActualEnd) {
    if (dateActualEnd !== null && dateActualEnd !== undefined) return -1;
    if (date === null || date === undefined) return -1;

    const end = date;
    const current = new Date().getTime() / 1000;

    if (end > 0 && current < end) {
        return parseInt((end - current) / 86400);
    }
    return 0;
}

function priorityTo(value) {
    let newValue = 0
    switch (value) {
        case 0: newValue = 0; break;
        case 1: newValue = 4; break;
        case 2: newValue = 3; break;
        case 3: newValue = 2; break;
        case 4: newValue = 1; break;
    } 

    return newValue
}

function sortByMultipleFields(array, sorts) {
    return array.sort((a, b) => {

        const activeSorts = Object.entries(sorts)
        .filter(([field, direction]) => direction !== 'none')
        .map(([field, direction]) => ({ field, direction }))

        for (const { field, direction } of activeSorts) {
            const multiplier = direction === 'desc' ? -1 : 1

            let valueA, valueB
            if (field === 'deadline') {
                valueA = daysTo(a.date_planned_end, a.date_actual_end)
                valueB = daysTo(b.date_planned_end, b.date_actual_end) 
            } else if (field === 'priority') {
                valueA = priorityTo(a.priority)
                valueB = priorityTo(b.priority)
            } else {                    
                valueA = a[field]
                valueB = b[field]
            }

            const result = compareValues(valueA, valueB);
            if (result !== 0) return result * multiplier;
        }

        return 0
    })
}

export default {
    components: {
        HomeNavigation,
        IndicatorDaysTo,
        ProgressBar
    },
    data() {
        return {
            Config,
            projectsList: [],
            tasksList: [],
            datUpdateTask: {
                statusName: '',
                id: 0,
                title: '',
                description: '',
                status_id: '',
                position: '',
                weight: 0,
                color: '#000000',
                errorText: '',
                date_create: 0,
                date_planned_end: '',
                date_planned_start: '',
                author: {},
                performer: [],
                files: [],
                priority: 0,
                imageFile: ''
            }, 
            filters: {
                name: '',
                deadline: null,
                status: '',
                percent: 100,
                performers: [],
                priority: [],
                files: 0,
                date_planned_start: null,
                date_planned_end: null
            },                       
            sorts: {
                title: 'none',
                status: 'none',                
                deadline: 'none',
                percent: 'none',
                priority: 'none',
                date_planned_start: 'none',
                date_planned_end: 'none'
            },
            psorts: {
                name: 'none',
                completion_percent: 'none'
            }, 
            projectSorting: '',           
            priorityValues             
        }
    },
    beforeMount: function () {
        this.getUserProjects()
        this.getUserTasks()
    },
    computed: {   
        userStore() {
            return useUserStore()
        },                     
        sortedTaskList: {
            get() {
                const searchTerm = this.filters.name.trim().toLowerCase()
                const fieldsToSearch = ['title', 'status', 'percent']

                if (this.tasksList.tasks) {
                    const tl = sortByMultipleFields(this.tasksList.tasks, this.sorts)

                    const result = tl.filter(item => {
                        return fieldsToSearch.some(field => 
                            String(item[field]).toLowerCase().includes(searchTerm)
                        )
                    })
                                        
                    return result
                } else {
                    return []
                }
            }
        }, 
        sortedProjects: {
            get() {
                if (this.projectsList) {
                    const tl = sortByMultipleFields(this.projectsList, this.psorts)                                      

                    return tl
                } else {
                    return []
                }
            }
        },
        tasksObject: {
            get() {
                let result = {
                    today: 0,
                    expired: 0,
                    failed: 0,
                    completed: 0,
                    occupied: {
                        count: 0,
                        value: 0,
                        progress: "0%"
                    }
                }    
                let today = new Date().getTime() / 1000
                let space = 0
                let count = 0

                this.tasksList.tasks?.forEach(task => {

                    task.subtask.forEach(subTask => {
                        if (subTask.files.length > 0) {
                            count += subTask.files.length
                            for(var fKey in subTask.files) {
                                space += subTask.files[fKey].fileSize
                            }                                
                        }
                    })                         
                    // !!!

                    if (!!task.date_actual_end) {
                        result.completed++
                    }
                    const start = task.date_planned_start
                    const end   = task.date_planned_end
                    // today
                    if ( !start ) {
                        if (end) {
                            if (today < end) {
                                result.today++
                            }
                        } else {
                            result.today++
                        }
                    } else 
                        if (!end) {
                            if (start < today) {
                                result.today++
                            }
                        } else {
                            if (start < today && end > today) {
                                result.today++
                            }
                        }
                    // Expired
                    if (start > 0 && end > 0) {
                        const section = ( end - start ) / 3
                        const current =  new Date().getTime() / 1000
                        
                        if (end - section < current && current < end) {
                            result.expired++
                        }                                
                    }                        
                    // failed
                    if ( start > 0 && end > 0 && end < today) {
                        result.failed++
                    } 
                })                                    

                return result
            }
        },               
    },
    methods: {
        ...mapActions('dashboard', ['listProjects', 'listTasks']),
        ...mapGetters('dashboard', ['getListProjects', 'getListTasks']),        
        ...mapActions('company', ['list', 'addCompany', 'delete']),
        ...mapGetters('company', ['getList']),   
        localeDateTime,

        async getUserProjects() {
            await this.listProjects()
            this.projectsList = this.getListProjects()
        },

        async getUserTasks() {
            await this.listTasks({count: 15, page: 1})
            this.tasksList = this.getListTasks()
        },

        sortIcon(field) {
            const direction = this.sorts[field]
            if (direction === 'asc') {
                return require('@/assets/images/icons/sort-asc.svg#icon')
            } else if (direction === 'desc') {
                return require('@/assets/images/icons/sort-desc.svg#icon')
            } else if (direction === 'none') {
                return require('@/assets/images/icons/sort-none.svg#icon')
            }
            return ''
        },

        attachSorting(field) {           
            if (!(field in this.sorts)) {
                console.error(`Поле "${field}" не существует в объекте sorts.`)
                return
            }

            Object.keys(this.sorts).forEach((key) => {
                if (key !== field) {
                    this.sorts[key] = 'none'
                }
            })
            
            const currentValue = this.sorts[field];

            if (currentValue === 'none') {
                this.sorts[field] = 'asc'
            } else if (currentValue === 'asc') {
                this.sorts[field] = 'desc'
            } else {
                this.sorts[field] = 'none'
            }
        }, 

        attachProjectsSorting(field, direction) {           
            Object.keys(this.psorts).forEach((key) => {
                if (key !== field) {
                    this.psorts[key] = 'none'
                }
            })
                        
            if (!(field in this.psorts)) {
                return
            }
            
            this.psorts[field] = direction
        },

        handleProjectSortingChange(event) {
            const selectedOption = event.target.options[event.target.selectedIndex]
            const selectedField = selectedOption.value
            const selectedDirection = selectedOption.dataset.direction

            this.attachProjectsSorting(selectedField, selectedDirection)
        }, 

        getPriorityObject(priority) {
            const priorityObj = this.priorityValues.find(option => option.value === priority);
            return priorityObj
        }, 

        getProgressColor(value) {
            let cl = "np-danger"
            if (value > 25 && value <= 50) {
                return "np-warning"
            } else {
                if (value > 25 && value <= 50) {
                    return "np-success"
                }
            }
            return cl
        },

        callSwitchScreen(target) {
            this.$emit("switchScreen", target)
        },

        showModTask(id, status, taskActiveTab="params", activeSubTaskID=null) {
            let datUpdateTask = {}
            
            this.tasksList?.tasks?.forEach(elementT => {
                if (id == elementT.id) {
                    datUpdateTask = {... elementT}
                }
            })
            
            datUpdateTask.statusName = status.title
            datUpdateTask.status_id  = status.id
        },

        expandRow(event, rowSelector) {
            const targetElement = event.target
            const elements = document.querySelectorAll(`.${rowSelector}`)
            
            targetElement.classList.toggle('expanded')

            elements.forEach((element) => {
                element.classList.toggle('hidden')
            })
        }            
    }

}
</script>

<style>
</style>